var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupplier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_1670946",
    clipPath: "url(#clip0_4850_18337)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6016 16.4655L12.2271 15.8709C11.9197 15.7942 11.5822 15.9013 11.3786 16.1698L9.57993 18.5402L7.7778 16.1655C7.5881 15.897 7.24609 15.759 6.90836 15.8451L4.07187 16.5721C1.64917 17.1931 0 19.3163 0 21.8135V24.3693C0 24.8224 0.367218 25.1896 0.820312 25.1896H14.7402C14.6505 24.9343 14.6016 24.6596 14.6016 24.3736V16.4655Z",
    fill: "#1A1AE6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4911 15.1108L22.9901 15.3616V13.436H21.2617V15.3616L21.7558 15.1134C21.9786 15.0002 22.2504 14.9906 22.4911 15.1108Z",
    fill: "#1A1AE6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1797 13.436H24.631V16.688C24.631 17.1411 24.2637 17.5083 23.8106 17.5083C23.6511 17.5083 23.502 17.4626 23.3759 17.3836L22.1262 16.7557L20.8071 17.4186C20.2579 17.694 19.6243 17.2823 19.6247 16.688L19.6213 13.436H17.0625C16.6094 13.436 16.2422 13.8035 16.2422 14.2563V24.3735C16.2422 24.8266 16.6094 25.1938 17.0625 25.1938H27.1797C27.6328 25.1938 28 24.8266 28 24.3735V14.2563C28 13.8033 27.6328 13.436 27.1797 13.436Z",
    fill: "#1A1AE6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1035 9.11572C15.1035 12.1663 12.6306 14.6392 9.58008 14.6392C6.52954 14.6392 4.05664 12.1663 4.05664 9.11572C4.05664 6.06519 6.52954 3.59229 9.58008 3.59229C12.6306 3.59229 15.1035 6.06519 15.1035 9.11572Z",
    fill: "#1A1AE6"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4850_18337"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0 0.42041)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupplier);
export default __webpack_public_path__ + "static/media/supplier.d925ad5a4895c44932d5a95e6fa930c7.svg";
export { ForwardRef as ReactComponent };